import { Center, Column, Screen, Spinner } from '@tempmee/react';
import { Pagination } from '~/commonComponents';
import {
  IDraftJobPostListViewEntity,
  IJobPostEntity,
  JobPostingStatus,
} from '~/domain/PermanentJobs';
import { DefaultTable, DraftTable, Header, SuspendedBanner } from './components';
import { useManageJobs } from './useManageJobs';

export const ManageJobs = () => {
  const {
    data, forms, initialStatus, isInitialLoading,
    isLoading, methods, pagination, statistics,
  } = useManageJobs();

  const isDraft = forms.filters.status === JobPostingStatus.Draft;

  return (
    <Screen variant="standard">
      <Screen.Header title="Permanent Jobs" />
      <Screen.Body>
        <SuspendedBanner counts={statistics.tabs.suspended} style={{ marginTop: 24 }} />
        <Header
          initialStatus={initialStatus}
          statistics={statistics.tabs}
          onValueChanges={(newValue) => {
            methods.setFormFilters(newValue);
            methods.setCurrentPage(1);
          }}
        />
        <Column px={20}>
          {isInitialLoading ? (
            <Center style={{ marginBlock: 32 }}>
              <Spinner centered variant="default" size="md" />
            </Center>
          ) : (
            <>
              {!isDraft ? (
                <DefaultTable
                  data={data as IJobPostEntity[]}
                  formSorting={forms.sorting}
                  isLoading={isLoading}
                  onSortChanges={methods.setFormSorting}
                />
              ) : (
                <DraftTable data={data as IDraftJobPostListViewEntity[]} isLoading={isLoading} />
              )}
              <Pagination
                currentPage={pagination.currentPage}
                totalPages={pagination.totalPages}
                onPageChange={methods.setCurrentPage}
              />
            </>
          )}
        </Column>
      </Screen.Body>
    </Screen>
  );
};
